import { render, staticRenderFns } from "./Other_records.vue?vue&type=template&id=b0882c10&scoped=true"
import script from "./Other_records.vue?vue&type=script&lang=js"
export * from "./Other_records.vue?vue&type=script&lang=js"
import style0 from "./Other_records.vue?vue&type=style&index=0&id=b0882c10&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0882c10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0882c10')) {
      api.createRecord('b0882c10', component.options)
    } else {
      api.reload('b0882c10', component.options)
    }
    module.hot.accept("./Other_records.vue?vue&type=template&id=b0882c10&scoped=true", function () {
      api.rerender('b0882c10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/memberCenter/views/member_management/components/Other_records.vue"
export default component.exports